import { useMemo } from 'react'
import { observer } from 'mobx-react-lite'
import { FormGroupContainer } from '@/components/FormContainer'
import {
  CustomSelect,
  SingleItemSelectedDefault,
} from '@/components/inputs/CustomSelect'
import { ItemSource } from '@/components/inputs/custom-select-state-observable'
import { useCustomSelectStateFromItemSource } from '@/components/inputs/item-source-hook'
import { EditUserRoleDialog } from '@/features/user-management/EditUserRoleDialog'
import { type EditUserRoleDialogViewModel } from './EditUserRoleDialogViewModel'

export interface EditUserRoleDialogContainerProps {
  vm: EditUserRoleDialogViewModel
}

export const EditUserRoleDialogContainer = observer(
  function EditUserRoleDialogContainer({
    vm,
  }: EditUserRoleDialogContainerProps) {
    const selectProps = useCustomSelectStateFromItemSource({
      itemSource: useMemo(
        () => ItemSource.static(vm.availableRoles),
        [vm.availableRoles],
      ),
    })

    return (
      <EditUserRoleDialog
        showing={vm.modal.showing}
        onClose={vm.close}
        selectedUserName={vm.selectedUserName}
        selectedUserCount={vm.selectedUserIds.length}
        workspaceName={vm.workspace.name}
        onSubmit={vm.submit}
        isSubmitPending={vm.submit.pending}
      >
        <FormGroupContainer
          label="Select a new role"
          error={vm.validation.getError('selectedRole')}
        >
          <CustomSelect
            {...selectProps}
            value={vm.selectedRole}
            onChange={vm.setSelectedRole}
            placeholder="Select new role"
            testId="edit-user-role-select-role"
            multi={false}
            itemToString={(v) => String(v?.name)}
            renderItem={(itemProps) => (
              <SingleItemSelectedDefault
                {...itemProps}
                item={itemProps}
                itemToString={(i) => i.item.name}
              />
            )}
          />
        </FormGroupContainer>
      </EditUserRoleDialog>
    )
  },
)
